import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import { RillContext } from "../../rill/RillReact/share/base";

class VideoModal extends React.Component {
  render() {
    const { locals } = this.context;
    const { query, origin } = locals;
    const { t } = this.props;

    return (
      <Modal width="1000px">
        <div className="head">{t("videoModal.welcomeVideo")}</div>
        <iframe
          className="Welcome-Video"
          src={`https://www.youtube.com/embed/ib9Axcatw1Y?rel=0&amp;showinfo=0&amp;autoplay=false`}
          allowFullScreen
        ></iframe>
      </Modal>
    );
  }
}

VideoModal.contextType = RillContext;

export default withTranslation("coaching-portal")(VideoModal);
